"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DocsApp_1 = require("./DocsApp");
exports.DocsApp = DocsApp_1.DocsApp;



//////////////////
// WEBPACK FOOTER
// ./src/docs/index.ts
// module id = 227
// module chunks = 0